export const productTypeQuestion = {
  id: 'productType',
  title: 'What type of product are you packaging?',
  options: [
    { value: 'readyMeals', label: 'Ready-to-eat meals', description: 'Entrees, meal prep dishes, hot bar items.' },
    { value: 'dipsSpreads', label: 'Dips & spreads', description: 'Hummus, salsa, queso, and similar items.' },
    { value: 'soupsSauces', label: 'Soups & sauces', description: 'Soups, sauces, and liquids that need to stay contained.' },
    { value: 'freshSalads', label: 'Fresh salads & produce', description: 'Fresh greens, deli salads, and produce items.' },
    { value: 'frozenFoods', label: 'Frozen foods', description: 'Frozen entrees, sides, and desserts.' },
    { value: 'otherFoods', label: 'Other food products', description: 'Custom applications or unique products.' }
  ]
};

export const portionSizeQuestion = {
  id: 'portionSize',
  title: 'What size portions do you need?',
  options: [
    { value: 'small', label: 'Small portions (4-12 oz)', description: 'Snacks, sides, single-serve dips.' },
    { value: 'medium', label: 'Medium portions (12-24 oz)', description: 'Lunch portions and hearty sides.' },
    { value: 'large', label: 'Large portions (24-32 oz)', description: 'Shareable entrees and family sides.' },
    { value: 'family', label: 'Family size (32+ oz)', description: 'Family-sized meals or bulk servings.' }
  ]
};

export const compartmentsQuestion = {
  id: 'compartments',
  title: 'Do you need multiple compartments?',
  options: [
    { value: 'single', label: 'Single compartment only', description: 'One main compartment.' },
    { value: 'two', label: '2 compartments', description: 'Keep two components separated.' },
    { value: 'threePlus', label: '3+ compartments', description: 'Ideal for full entrees with sides.' },
    { value: 'notSure', label: 'Not sure', description: 'Show me the most versatile options.' }
  ]
};

export const useCaseQuestion = {
  id: 'useCase',
  title: "What's your primary use case?",
  options: [
    { value: 'microwave', label: 'Microwave heating', description: 'Designed for convenient reheating.' },
    { value: 'oven', label: 'Oven heating (conventional)', description: 'Handles high heat for oven applications.' },
    { value: 'coldOnly', label: 'Cold consumption only', description: 'Served cold or room temperature.' },
    { value: 'multiple', label: 'Multiple heating methods', description: 'Needs to handle microwave + oven or freezer.' },
    { value: 'notSure', label: 'Not sure', description: 'Help me choose the safest option.' }
  ]
};

export const guidanceSteps = [
  productTypeQuestion,
  portionSizeQuestion,
  compartmentsQuestion,
  useCaseQuestion
];

export const portionSizeToRange = {
  small: { min: 4, max: 12 },
  medium: { min: 12, max: 24 },
  large: { min: 24, max: 32 },
  family: { min: 32, max: Infinity }
};

export const valueToCompartments = {
  single: { min: 1, max: 1 },
  two: { min: 2, max: 2 },
  threePlus: { min: 3, max: Infinity },
  notSure: null
};

export const filmProcessDefaultsByUseCase = {
  microwave: ['Microwaved'],
  oven: ['Oven'],
  coldOnly: ['Refrigerated'],
  multiple: ['Microwaved', 'Oven', 'Frozen'],
  notSure: []
};

export const filmProcessDefaultsByProductType = {
  frozenFoods: ['Frozen'],
  freshSalads: ['Refrigerated'],
  dipsSpreads: ['Refrigerated'],
  soupsSauces: ['Microwaved'],
  readyMeals: ['Microwaved'],
  otherFoods: []
};

export const containerTypeCopy = {
  meal: {
    label: 'Meal Trays',
    description:
      'Durable trays that support reheating and multi-compartment layouts, perfect for entrees and hot applications.'
  },
  deli: {
    label: 'Deli Containers',
    description:
      'Clear, single-compartment containers that showcase refrigerated dips, salads, and sauces.'
  }
};
